export function preventDefault(callback, ...args) {
  return event => {
    event.preventDefault();
    callback(event, ...args);
  };
}

export function addClass(className) {
  return el => {
    el.classList.add(className);
  };
}

export function removeClass(className) {
  return el => {
    el.classList.remove(className);
  };
}

export function on(eventName, callback) {
  return el => {
    el.addEventListener(eventName, callback);
  };
}
